<common-top-tool-bar
  [title]="'批量添加英语王者题库'"
  [back]="'/admin/v3/game/exercise-bank'"
  [actionsTemplate]="batchActions"
>
  <ng-template #batchActions>
    <button
      nz-button
      nzType="primary"
      class="mr-4"
      nzSize="large"
      nzGhost
      type="button"
      routerLink="/admin/v3/game/exercise-bank"
    >
      取消
    </button>
    <button nz-button nzType="primary" nzSize="large" type="button" [nzLoading]="submitting" (click)="submit()">
      提交
    </button>
  </ng-template>
</common-top-tool-bar>

<div class="page-tab-main v3">
  <nz-spin [nzSpinning]="loadingInit">
    <div class="page-main">
      <div class="page-main-wrapper game-form-edit-wrapper">
        <form nz-form [formGroup]="form">
          <div nz-row nzGutter="36">
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzRequired>级别</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-select
                    formControlName="levelId"
                    nzAllowClear
                    nzShowSearch
                    nzPlaceHolder="请选择游戏级别"
                    nzSize="large"
                    style="width: 100%"
                  >
                    <nz-option *ngFor="let lv of gameLevels" [nzValue]="lv.id" [nzLabel]="lv.name + ' (' + lv.levelCode + ')'"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label [nzSpan]="24" nzRequired>资源路径</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <nz-cascader
                    style="width: 100%"
                    nzAllowClear
                    nzShowSearch
                    nzPlaceHolder="请选择二级资源路径"
                    [nzOptions]="pathCascaderOptions"
                    [nzValueProperty]="'id'"
                    [nzLabelProperty]="'name'"
                    [nzChangeOnSelect]="false"
                    [(ngModel)]="pathCascaderValues"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onPathCascaderChange($event)"
                  ></nz-cascader>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <ng-container *ngIf="pathCascaderValues?.length >= 2">
            <div nz-row nzGutter="36">
              <div nz-col nzSpan="24">
                <div class="package-toolbar">
                  <button
                    nz-button
                    nzType="dashed"
                    type="button"
                    [disabled]="!canAddPackage()"
                    (click)="addPackageRow()"
                  >
                    <i nz-icon nzType="plus" nzTheme="outline"></i>
                    添加题包
                  </button>
                  <span class="package-hint" *ngIf="packagesLoading">正在加载题包列表…</span>
                  <span class="package-hint" *ngIf="!packagesLoading && !exercisePackageOptions.length">当前资源路径无题库</span>
                </div>
              </div>
            </div>

            <div formArrayName="packages" class="packages-wrap">
              <div
                *ngFor="let pkg of packages.controls; let i = index"
                [formGroupName]="i"
                class="package-row"
              >
                <div class="package-card relative">
                  <button
                    nz-button
                    nzType="text"
                    nzDanger
                    type="button"
                    class="package-remove-btn"
                    (click)="removePackageRow(i)"
                    nz-tooltip
                    nzTooltipTitle="移除此题包"
                  >
                    <i nz-icon nzType="minus-circle" nzTheme="fill"></i>
                  </button>
                  <div nz-row nzGutter="36">
                    <div nz-col nzSpan="12">
                      <nz-form-item class="pkg-form-item">
                        <nz-form-label [nzSpan]="24" nzRequired>题包</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <nz-select
                            [formControl]="getPkgControl(i, 'exerciseId')"
                            nzAllowClear
                            nzShowSearch
                            nzPlaceHolder="选择题包"
                            nzSize="large"
                            style="width: 100%"
                          >
                            <nz-option
                              *ngFor="let p of exercisePackageOptions"
                              [nzValue]="p.id"
                              [nzLabel]="p.name"
                            ></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    <div nz-col nzSpan="12">
                      <nz-form-item class="pkg-form-item">
                        <nz-form-label [nzSpan]="24" nzRequired>题目</nz-form-label>
                        <nz-form-control [nzSpan]="24">
                          <nz-select
                            [formControl]="getPkgControl(i, 'bankIds')"
                            nzMode="multiple"
                            nzShowSearch
                            nzPlaceHolder="请勾选题目（可多选）"
                            nzSize="large"
                            style="width: 100%"
                          >
                            <nz-option
                              *ngFor="let it of itemOptionsForRow(getPkgControl(i, 'rowId').value)"
                              [nzValue]="it.id"
                              [nzLabel]="it.name"
                            ></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </form>
      </div>
    </div>
  </nz-spin>
</div>
